module.exports = __webpack_public_path__ + "assets/img/free_34.7b2dcbc5.png";